import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.7 4.40005C19.6 2.90005 18.4 1.80005 17 1.80005H6.99999C5.49999 1.80005 4.29999 3.00005 4.29999 4.40005C3.09999 4.70005 2.29999 5.80005 2.29999 7.00005V19C2.29999 20.5 3.49999 21.8 5.09999 21.8H19.1C20.6 21.8 21.9 20.6 21.9 19V7.00005C21.8 5.70005 20.9 4.70005 19.7 4.40005ZM6.99999 3.20005H17C17.6 3.20005 18.1 3.60005 18.2 4.20005H5.79999C5.89999 3.70005 6.39999 3.20005 6.99999 3.20005ZM20.2 19C20.2 19.7001 19.6 20.2001 19 20.2001H4.99999C4.29999 20.2001 3.79999 19.6 3.79999 19V7.00005C3.79999 6.30005 4.39999 5.80005 4.99999 5.80005H19C19.7 5.80005 20.2 6.40005 20.2 7.00005V19Z" />
        <path d="M15 14.9C15.4 14.2 15.7 13.4 15.7 12.6C15.7 10.2 13.8 8.30005 11.5 8.30005C9.19999 8.30005 7.29999 10.2 7.29999 12.6C7.29999 15 9.19999 16.9 11.5 16.9C12.4 16.9 13.3 16.6 14 16.1L15.5 17.7C15.6 17.9 15.8 17.9 16 17.9C16.2 17.9 16.4 17.8 16.5 17.7C16.8 17.4 16.8 16.9 16.5 16.6L15 14.9ZM8.79999 12.5C8.79999 11 9.99999 9.70005 11.5 9.70005C13 9.70005 14.2 10.9 14.2 12.5C14.2 14.1 13 15.3 11.5 15.3C9.99999 15.3 8.79999 14.1 8.79999 12.5Z" />
      </svg>
    ),
  },
});
